module.exports = __webpack_public_path__ + "img/2-1.e44b567c.svg";